import { Fancybox } from '@fancyapps/ui';

export default function initFancybox() {
  Fancybox.bind('[data-fancybox]', {
    on: {
      reveal: (fancybox, slide) => {
        slide.contentEl.append(slide.captionEl);
      },
    },
    Toolbar: {
      items: {
        close: {
          tpl: '<div class="fb-close-holder"><span class="text"></span><button class="f-button" title="{{CLOSE}}" data-fancybox-close><svg><path d="m19.5 4.5-15 15M4.5 4.5l15 15"/></svg></button></div>',
        },
      },
      display: {
        left: [],
        middle: [],
        right: ["close"],
      },
    },
    Thumbs: false,
    contentClick: false,
    Images: {
      zoom: false,
    },
    Carousel: {
      Navigation: {
        nextTpl: '<span class="icon-arrow-right"></span>',
        prevTpl: '<span class="icon-arrow-left"></span>',
      },
    },
    Hash: false,
    dragoble: false,
    dragToClose: false,
  });
}